import request from '@/utils/request'

// old
export function getCategory2() {
  return request({
    url: '/admin2/category/selectActiveCategorys',
    method: 'get'
  })
}

export function getSeason2() {
  return request({
    url: '/admin2/product/filter/season/list',
    method: 'get',
  })
}

export function getBrand2() {
  return request({
    url: '/admin2/product/filter/brand/list',
    method: 'get',
  })
}

export function getVendor2() {
  return request({
    url: '/admin2/vendor/select/queryAllVendor',
    method: 'get'
  })
}
// old end

export function getCategory() {
  return request({
    url: '/basic-backend/category/tree',
    method: 'get'
  })
}

export function getSeason() {
  return request({
    url: '/product-service/season/list',
    method: 'get',
  })
}

export function getBrand() {
  return request({
    url: '/product-service/brand/list',
    method: 'get',
  })
}

export function getVendor() {
  return request({
    url: '/product-service/vendor/select/queryAllVendor',
    method: 'get'
  })
}

export function getPromotionRules(ruleType, promotionId) {
  return request({
    url: "/admin2/promotion/" + ruleType + ((promotionId === undefined || promotionId === "") ? "" : "?promotionId=" + promotionId),
    method: 'get',
  })
}

export function createRule(ruleType, payload) {
  return request({
    url: '/admin2/promotion/' + ruleType,
    method: 'POST',
    data: payload,
  })
}


export function editRule(ruleType, payload) {
  return request({
    url: '/admin2/promotion/' + ruleType,
    method: 'put',
    data: payload,
  })
}


export function deleteRule(ruleType, ruleId) {
  return request({
    url: '/admin2/promotion/' + ruleType + '/' + ruleId,
    method: 'delete',
  })
}

export function getPromotions(bannerId) {
  return request({
    url: "campaign/active/" + bannerId,
    method: 'get',
    baseURL: process.env.VUE_APP_PRODUCT_API,
  })
}


export function addExcludeProduct(payload) {
  return request({
    url: "/admin2/promotion/product/exclude",
    method: "PUT",
    data: payload,
  })
}

export function getExcludeProduct(promotionId) {
  return request({
    url: "/admin2/promotion/product/exclude?promotionId=" + promotionId,
    method: "GET",
  })
}

export function removeExcludeProduct(params) {
  return request({
    url: "/admin2/promotion/product/exclude",
    method: "DELETE",
    data:params,
  })
}

export function getBannerList() {
  return request({
    url: "/admin2/banner/bannerPosList",
    method: "GET",
  })
}

export function getPromotionImage(promotionId) {
  return request({
    url: "/admin2/banner/promotion/pid?promotionId=" + promotionId,
    method: "GET",
  })
}

export function savePromotionImage(images) {
  return request({
    url: '/admin2/banner/updateImg',
    method: 'put',
    data: images,
  })
}

export function getRecomandBrands(promotionId) {
  return request({
    url: "/admin2/banner/promotion/brandhot?promotionId=" + promotionId,
    method: "GET",
  })
}

export function getSortPromotionTabs(promotionId) {
  return request({
    url: "/admin2/sort/promotion/" + promotionId,
    method: "GET",
  })
}

export function saveRecomandBrandList(data, promotionId) {
  return request({
    url: "/admin2/banner/promotion/"+promotionId+"/brandhot",
    method: "put",
    data: data,
  })
}

export function saveMenuList(promotionId, data) {
  return request({
    url: "/admin2/sort/promotion/" + promotionId,
    method: "put",
    data: data,
  });
}

export function getMenuSortDetail(promotionId, type) {
  return request({
    url: "/admin2/sort/promotion/" + promotionId + "/" + type,
    method: "get",
  })
}

export function saveMenuSortDetail(promotionId, type, data) {
  return request({
    url: "/admin2/sort/promotion/" + promotionId + "/" + type,
    method: "put",
    data: data,
  })
}

export function refreshSnapshot(promotionId) {
  return request({
    url: "/admin2/promotion/refresh/" + promotionId,
    method: "put",
  })
}

export function importIncludeFile(data) {
  return request({
    data: data,
    url: '/admin2/promotion/include_import',
    method: 'POST',
  })
}

export function deleteCampaign(data) {
  return request({
    url: "campaign/delete",
    method: 'POST',
    baseURL: process.env.VUE_APP_PRODUCT_API,
    data: data
  })
}

export function newCampaign(data) {
  return request({
    url: "campaign/new",
    method: 'POST',
    baseURL: process.env.VUE_APP_PRODUCT_API,
    data: data
  })
}

export function searchProduct(data) {
  return request({
    url: "campaign/product/search?designerId=" + data.designerId + "&colorCode=" + data.colorCode + "&pageNo=" + data.pageNo + "&pageSize=" + data.pageSize,
    method: 'GET',
    baseURL: process.env.VUE_APP_PRODUCT_API
  })
}


export function getRuleBySeason(param) {
  return request({
    url: "/admin2/promotion/" + param.ruleType + "?promotionId=" + param.campaignId + "&vendorId="+param.vendorId+"&seasonCode="+param.seasonCode+ "&pageNo="+param.pageNo+"&pageSize="+param.pageSize,
    method: "GET",
  })
}

export function deleteMultiRule(type, ruleIds) {
  return request({
    url: "/admin2/promotion/delete/vendor/" + type + "?ruleIds=" + ruleIds,
    method: "DELETE",
  })
}

export function deleteSesonRule(vendorId, season, campaignId) {
  return request({
    url: "campaign/delete/vendor/season/" +  vendorId + "/" + campaignId + '/' + season,
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "DELETE"
  })
}

export function deleteVendorRule(vendorId, campaignId) {
  return request({
    url: "campaign/delete/vendor/" + vendorId + "/" + campaignId,
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "DELETE"
  })
}

export function getProductGroupVendor() {
  return request({
    url: "campaign/exclude/product/group/vendor",
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "GET"
  })
}

export function getProductGroupsByVendorId(vendorId) {
  return request({
    url: "campaign/exclude/product/group/" + vendorId + "?orderBy=date",
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "GET"
  })
}

export function addExcludeProductGroup(promotionId, tagId) {
  return request({
    url: "campaign/exclude/product/group/add/" + promotionId + "/" + tagId,
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "POST"
  })
}

export function delExcludeProductGroup(ids) {
  return request({
    url: "campaign/exclude/product/group/delete?ids=" + ids,
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "POST"
  })
}

export function getExcludeProductGroup(promotionId) {
  return request({
    url: "campaign/exclude/product/group/get/" + promotionId,
    baseURL: process.env.VUE_APP_PRODUCT_API,
    method: "GET"
  })
}
